import React, { useEffect } from 'react';
import { createUnauthenticatedCheckoutSession } from '@/integrations/stripe/client';
import { Loader2 } from 'lucide-react';
import { useSearchParams } from 'react-router';
import posthog from 'posthog-js';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import { toast } from 'sonner';

/**
 * Simplified Subscribe page that automatically redirects to Stripe checkout
 */
export default function Subscribe() {
  const [searchParams] = useSearchParams();
  const promoCode = searchParams.get('code');
  const { t } = useTranslation();

  // Automatically redirect to checkout on page load
  useEffect(() => {
    const redirectToCheckout = async () => {
      try {
        // Track payment initiation (anonymously)
        try {
          posthog.capture('payment_started', {
            promo_code: promoCode || undefined
          });
        } catch (err) {
          console.error('Error tracking payment started:', err);
        }
        
        // Redirect to checkout
        await createUnauthenticatedCheckoutSession({
          locale: i18next.language,
          promo_code: promoCode || undefined
        });
      } catch (err) {
        console.error('Subscription error:', err);
        toast.error(t('subscribe.error.title'), {
          description: t('subscribe.error.checkout'),
          duration: 5000
        });
        
        posthog.capture('payment_failed', {
          error: err instanceof Error ? err.message : 'Unknown error'
        });
      }
    };
    
    redirectToCheckout();
  }, [promoCode, t]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-4">
      <div className="flex flex-col items-center space-y-4">
        <Loader2 className="h-12 w-12 animate-spin text-primary" />
        <h2 className="text-xl font-medium">{t('subscribe.redirecting')}</h2>
        <p className="text-muted-foreground text-center max-w-md">
          {t('subscribe.redirectingDescription')}
        </p>
      </div>
    </div>
  );
}
